/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Errors_Invite_Already_ExistsInputs */

const nl_invite_errors_invite_already_exists = /** @type {(inputs: Invite_Errors_Invite_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er bestaat al een uitnodiging voor dit e-mailadres`)
};

/**

* @param {Invite_Errors_Invite_Already_ExistsInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const invite_errors_invite_already_exists = /** @type {((inputs?: Invite_Errors_Invite_Already_ExistsInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Errors_Invite_Already_ExistsInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_invite_errors_invite_already_exists(inputs)
});
export { invite_errors_invite_already_exists as "invite.errors.invite_already_exists" }